import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { formatShortDate } from "@/lib/api";

export const ArticleCard = ({ item, index = 0, prefix = "news" }) => (
  <Link
    to={`/${prefix}/${item.slug}`}
    className="group block reveal"
    style={{ animationDelay: `${index * 70}ms` }}
    data-testid={`${prefix}-card-${item.id}`}
  >
    <div className="overflow-hidden aspect-square bg-[hsl(var(--surface))]">
      <img src={item.image || "/brand/fallback-magazine.jpg"} alt={item.title} loading="lazy" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
    </div>
    <p className="text-xs uppercase tracking-[0.2em] font-bold text-primary mt-5">
      {formatShortDate(item.date)}
      {item.categories?.filter((c) => c !== "News").slice(0, 2).map((c) => (
        <span key={c} className="text-zinc-400"> · {c === "Video" ? "Vidéo" : c}</span>
      ))}
      {item.podcast_type && <span className="text-zinc-400"> · {item.podcast_type}</span>}
    </p>
    <h3 className="font-display uppercase text-2xl lg:text-3xl leading-[0.95] mt-2 text-white group-hover:text-primary transition-colors duration-200 flex items-start gap-2">
      {item.title} <ArrowUpRight className="w-6 h-6 shrink-0 opacity-0 group-hover:opacity-100 transition-opacity" />
    </h3>
    <p className="text-zinc-400 text-sm mt-3 line-clamp-3 leading-relaxed">{item.excerpt}</p>
  </Link>
);
